import * as React from 'react';
export const PopupContext = /*#__PURE__*/React.createContext(null);